/**
 * Aplica src/tenant/tenant.config.js sobre los tokens --dk-* del documento.
 * Solo sobrescribe las variables de marca y de fuente; el resto de tokens
 * (neutros, espaciado, radios…) y todo lo derivado de la marca se resuelve en
 * CSS (tokens-despacho.css) sin intervención de JS.
 * Un valor inválido se ignora y queda el del CSS (por defecto Despacho).
 */
import defaultConfig from './tenant.config.js'
import { logEvent, logWarn } from '../lib/log.js'

const HEX = /^#[0-9a-fA-F]{6}$/
const FAMILIA = /^[\w .-]{1,64}$/
const MAPA_COLORES = {
  principal: '--dk-principal',
  profundo: '--dk-profundo',
  acento: '--dk-acento',
}

/** Variables CSS que produce una config (función pura, testeable). */
export function variablesDeTenant(config) {
  const vars = {}
  for (const [clave, variable] of Object.entries(MAPA_COLORES)) {
    const valor = config?.colores?.[clave]
    if (valor == null) continue
    if (HEX.test(valor)) vars[variable] = valor
    else logWarn('tenant_color_invalido', { code: clave })
  }
  const familia = config?.fuente?.familia
  if (familia != null) {
    if (FAMILIA.test(familia)) vars['--dk-font-familia'] = `'${familia}'`
    else logWarn('tenant_fuente_invalida', {})
  }
  return vars
}

const ID_HOJA_FUENTE = 'dk-tenant-fuente'

export function aplicarTenant(config = defaultConfig, doc = document) {
  const root = doc.documentElement
  const vars = variablesDeTenant(config)
  for (const [variable, valor] of Object.entries(vars)) root.style.setProperty(variable, valor)

  const url = config?.fuente?.url
  doc.getElementById(ID_HOJA_FUENTE)?.remove()
  if (url && /^https:\/\//.test(url)) {
    const link = doc.createElement('link')
    link.id = ID_HOJA_FUENTE
    link.rel = 'stylesheet'
    link.href = url
    doc.head.appendChild(link)
  } else if (url) {
    logWarn('tenant_fuente_url_descartada', {})
  }
  logEvent('tenant_aplicado', { count: Object.keys(vars).length })
  return vars
}
